import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import {
    ESegmentClickType,
    ESegmentClickTypeEventOption
} from '../../../../../../../../middlewares/segment/constants';
import { EButtonType } from '../types';

export const onDoubleClick = (
    source: EButtonType
): ThunkAction => {
    return (
        dispatch: Dispatch
    ) => {
        if (source === EButtonType.DATE) {
            dispatch(segmentTrackAction(SegmentCardEvent.DATE_BUTTON_CLICKED, {
                name: ESegmentClickTypeEventOption.CLICK_TYPE,
                value: ESegmentClickType.double
            }));
        }
        if (source === EButtonType.TIME) {
            dispatch(segmentTrackAction(SegmentCardEvent.TIME_BUTTON_CLICKED, {
                name: ESegmentClickTypeEventOption.CLICK_TYPE,
                value: ESegmentClickType.double
            }));
        }
    };
};
